// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2TOTA","content":"LoadingAlert_content__3PGA6"};